module.exports = __webpack_public_path__ + "static/media/minion-working.9a84f7b3.png";